import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  field: {
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
  },
  error:{
    color: "red",
    marginLeft: 15,
    fontSize:13,
    paddingTop:2,
    marginTop: 0
  }
}));

export default useStyles;
